import { render, staticRenderFns } from "./ApplianceRepairs.vue?vue&type=template&id=88b5fe6e"
import script from "./ApplianceRepairs.vue?vue&type=script&lang=js"
export * from "./ApplianceRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports